<template>
     <div class="modal-card">

       
                  
                    <!-- <header class="modal-card-head "  >
       

                        <b-button type="is-text" 
                           size="is-large"
                           icon-left="close-box" 
                          @click="close"></b-button>      
                   

                      
                    </header> -->



                    <section class="modal-card-body">
                             <b-field>
                                <b-checkbox v-model="hematology">
                                    Hematology
                                </b-checkbox>
                             </b-field>

                             <b-field>
                                <b-checkbox v-model="blood_chem">
                                    Blood Chemistry
                                </b-checkbox>
                             </b-field>


                             <b-field>
                                <b-checkbox v-model="body_fluid">
                                    Body Fluid
                                </b-checkbox>
                             </b-field>


                             <b-field>
                                <b-checkbox v-model="blood_gas">
                                    Blood Gas
                                </b-checkbox>
                             </b-field>


                             <b-field>
                                <b-checkbox v-model="hormone">
                                    Hormone
                                </b-checkbox>
                             </b-field>


                             <b-field>
                                <b-checkbox v-model="outlab">
                                    Outlab
                                </b-checkbox>
                             </b-field>


                              

                    
                    </section>
                    <footer class="modal-card-foot" style="justify-content: space-between;" >
                         <b-button type="is-danger" 
                           icon-left="close-box" 
                          @click="close">Close</b-button> 


                        <b-button type="is-success" @click="closeWithRequest">OK</b-button>                        
                    </footer>



                    


       




                </div>
</template>


<script>
export default {
    name : "DlgSelectGrpLABForViewTable",
    created() {
            const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
                this.close()
                next(false)
            })

            this.$once('hook:destroyed', () => {
                unregisterRouterGuard()
            })
    },
    props:{
        isShowing : Boolean,
    },
    methods:{
       close(){
          this.$emit('close')
       },
       closeWithRequest(){
         this.$emit('closeWithRequest',{
                                        "hematology"  : this.hematology,
                                        "blood_chem"  : this.blood_chem,
                                        "body_fluid"  : this.body_fluid,
                                        "blood_gas"   : this.blood_gas,
                                        "hormone"     : this.hormone,
                                        "outlab"      : this.outlab

                 })
       }  
    },
    data(){
        return{
            "hematology"  : true,
            "blood_chem"  : true,
            "body_fluid"  : false,
            "blood_gas"   : false,
            "hormone"     : false,
            "outlab"      : false 
        }
    }
}
</script>